export enum CATEGORIES_KEY {
  CATEGORY_SCIENCE = "science",
  CATEGORY_HEALTH = "health",
  // CATEGORY_AED = "aed",
  CATEGORY_FACILITY = "facilities",
  // CATEGORY_HEATER = "heater",
}

export const CATEGORIES = {
  [CATEGORIES_KEY.CATEGORY_SCIENCE]: "理科機器",
  [CATEGORIES_KEY.CATEGORY_HEALTH]: "保健福祉",
  // [CATEGORIES_KEY.CATEGORY_AED]: "救急救命",
  [CATEGORIES_KEY.CATEGORY_FACILITY]: "教育施設",
  // [CATEGORIES_KEY.CATEGORY_HEATER]: "工業用ヒーター",
};

export interface ICatalog {
  id?: string;
  category?: string;
  title?: string;
  year?: number;
  month?: number;
  is_image_url: number;
  image_url: string;
  image_id?: number;
  catalog_url?: string;
  excel_type?: string;
  excel_url?: string;
  excel_file_id?: number;
  pdf_type?: string;
  pdf_url?: string;
  pdf_file_id?: number;
}

export class CatalogDTO implements ICatalog {
  id? = null;
  category? = null;
  title? = "";
  year? = null;
  month? = null;
  is_image_url = null;
  image_url = null;
  image_id = null;
  catalog_url? = null;
  excel_type? = null;
  excel_url? = null;
  excel_file_id? = null;
  pdf_type? = null;
  pdf_url? = null;
  pdf_file_id? = null;
}

export default class Catalog extends CatalogDTO {
  original = {};
  constructor(dto?: CatalogDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      id: null,
      category: null,
      title: "",
      year: null,
      month: null,
      is_image_url: 1,
      image_id: null,
      catalog_url: null,
      excel_type: "none",
      excel_url: null,
      excel_file_id: null,
      pdf_type: "none",
      pdf_url: null,
      pdf_file_id: null,
    });
  }
}
